import { NgModule } from '@angular/core';
import { HeaderComponent } from './header.component';
import { LanguageModule } from '../../app-shared/components/language/language.module';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './menu/menu.component';
import { RouterModule } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { RoundPipeModule } from '../../app-shared/pipes/round-pipe/round.pipe.module';
import { ChangeUserFormModule } from '../../app-shared/components/change-user-form/change-user-form.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateSharedLazyModule } from '../../app-shared/modules/translate-shared-lazy.module';
import { OutsideClickModule } from '../../app-shared/directives/outside-click.module';
import { SearchModule } from '../../app-shared/components/search/search.module';
import { MoreModule } from './menu/more/more.module';
import { TooltipModule } from '../../app-shared/components/tooltip/tooltip.module';
import {LazyLoadingModulesModule} from "../../app-shared/directives/lazy-loading-modules.module";
import { EquipmentModule } from 'src/app/equipment/equipment.module';
import {ClipboardModule} from "@angular/cdk/clipboard";
import {FieldSelectInputModule} from "../../app-shared";
import {SubHeaderComponent} from "./sub-header/sub-header.component";
import {ChangeOutletModule} from "./change-outlet/change-outlet.module";

@NgModule({
  declarations: [HeaderComponent, MenuComponent, SubHeaderComponent],
  imports: [
    CommonModule,
    LanguageModule,
    RouterModule,
    MatMenuModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateSharedLazyModule,
    RoundPipeModule,
    ChangeUserFormModule,
    OutsideClickModule,
    SearchModule,
    MoreModule,
    TooltipModule,
    LazyLoadingModulesModule,
    EquipmentModule,
    ClipboardModule,
    FieldSelectInputModule,
    ChangeOutletModule
  ],
  exports: [HeaderComponent, MenuComponent, SubHeaderComponent],
})
export class HeaderModule {}
